import { useState } from 'react'
import { Form, Button, Row, Col, Badge, Alert, Card } from 'react-bootstrap'

// Catálogos SAT (alineados a facturación / CFDI 4.0)
const USO_CFDI_OPTIONS = [
  { value: 'G01', label: 'G01 - Adquisición de mercancías' },
  { value: 'G02', label: 'G02 - Devoluciones, descuentos o bonificaciones' },
  { value: 'G03', label: 'G03 - Gastos en general' },
  { value: 'I01', label: 'I01 - Construcciones' },
  { value: 'I02', label: 'I02 - Mobiliario y equipo de oficina por inversiones' },
  { value: 'I03', label: 'I03 - Equipo de transporte' },
  { value: 'I04', label: 'I04 - Equipo de computo y accesorios' },
  { value: 'I05', label: 'I05 - Dados, troqueles, moldes, matrices y herramental' },
  { value: 'I06', label: 'I06 - Comunicaciones telefónicas' },
  { value: 'I07', label: 'I07 - Comunicaciones satelitales' },
  { value: 'I08', label: 'I08 - Otra maquinaria y equipo' },
  { value: 'D01', label: 'D01 - Honorarios médicos, dentales y gastos hospitalarios' },
  { value: 'D02', label: 'D02 - Gastos médicos por incapacidad o discapacidad' },
  { value: 'D03', label: 'D03 - Gastos funerales' },
  { value: 'D04', label: 'D04 - Donativos' },
  { value: 'D05', label: 'D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)' },
  { value: 'D06', label: 'D06 - Aportaciones voluntarias al SAR' },
  { value: 'D07', label: 'D07 - Primas por seguros de gastos médicos' },
  { value: 'D08', label: 'D08 - Gastos de transportación escolar obligatoria' },
  { value: 'D09', label: 'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones' },
  { value: 'D10', label: 'D10 - Pagos por servicios educativos (colegiaturas)' },
  { value: 'S01', label: 'S01 - Sin efectos fiscales' },
  { value: 'CP01', label: 'CP01 - Pagos' },
  { value: 'CN01', label: 'CN01 - Nómina' },
]

const FORMA_PAGO_OPTIONS = [
  { value: '01', label: '01 - Efectivo' },
  { value: '02', label: '02 - Cheque nominativo' },
  { value: '03', label: '03 - Transferencia electrónica de fondos' },
  { value: '04', label: '04 - Tarjeta de crédito' },
  { value: '05', label: '05 - Monedero electrónico' },
  { value: '06', label: '06 - Dinero electrónico' },
  { value: '08', label: '08 - Vales de despensa' },
  { value: '12', label: '12 - Dación en pago' },
  { value: '13', label: '13 - Pago por subrogación' },
  { value: '14', label: '14 - Pago por consignación' },
  { value: '15', label: '15 - Condonación' },
  { value: '17', label: '17 - Compensación' },
  { value: '23', label: '23 - Novación' },
  { value: '24', label: '24 - Confusión' },
  { value: '25', label: '25 - Remisión de deuda' },
  { value: '26', label: '26 - Prescripción o caducidad' },
  { value: '27', label: '27 - A satisfacción del acreedor' },
  { value: '28', label: '28 - Tarjeta de débito' },
  { value: '29', label: '29 - Tarjeta de servicios' },
  { value: '30', label: '30 - Aplicación de anticipos' },
  { value: '31', label: '31 - Intermediario pagos' },
  { value: '99', label: '99 - Por definir' },
]

const optValue = (opt) => (typeof opt === 'string' ? opt : opt.value)
const optLabel = (opt) => (typeof opt === 'string' ? opt : opt.label)

// Campos disponibles para condiciones
const FIELDS = {
  clave_prod_serv: { label: 'Clave SAT', type: 'text' },
  descripcion: { label: 'Descripción', type: 'text' },
  importe: { label: 'Importe', type: 'number' },
  cantidad: { label: 'Cantidad', type: 'number' },
  valor_unitario: { label: 'Valor Unitario', type: 'number' },
  tipo_gasto: { label: 'Tipo de Gasto', type: 'enum', options: ['I', 'E', 'P', 'N', 'T'] },
  uso_cfdi: { label: 'Uso CFDI', type: 'enum', options: USO_CFDI_OPTIONS },
  forma_pago: { label: 'Forma de pago', type: 'enum', options: FORMA_PAGO_OPTIONS },
  metodo_pago: {
    label: 'Método de pago',
    type: 'enum',
    options: [
      { value: 'PUE', label: 'PUE - Pago en una sola exhibición' },
      { value: 'PPD', label: 'PPD - Pago en parcialidades o diferido' },
    ],
  },
}

// Operadores por tipo de campo
const getOperators = (fieldType) => {
  if (fieldType === 'text' || fieldType === 'enum') {
    return [
      { value: 'equals', label: 'Igual a', symbol: '=' },
      { value: 'not_equals', label: 'Diferente de', symbol: '≠' },
      { value: 'contains', label: 'Contiene', symbol: 'contiene' },
      { value: 'not_contains', label: 'No contiene', symbol: 'no contiene' },
      { value: 'starts_with', label: 'Empieza con', symbol: 'empieza con' },
      { value: 'ends_with', label: 'Termina con', symbol: 'termina con' },
      { value: 'in', label: 'Está en (lista)', symbol: 'en' },
      { value: 'not_in', label: 'No está en (lista)', symbol: 'no en' }
    ]
  } else if (fieldType === 'number') {
    return [
      { value: 'equals', label: 'Igual a', symbol: '=' },
      { value: 'not_equals', label: 'Diferente de', symbol: '≠' },
      { value: 'greater_than', label: 'Mayor que', symbol: '>' },
      { value: 'greater_equal', label: 'Mayor o igual que', symbol: '≥' },
      { value: 'less_than', label: 'Menor que', symbol: '<' },
      { value: 'less_equal', label: 'Menor o igual que', symbol: '≤' },
      { value: 'between', label: 'Entre', symbol: 'entre' },
      { value: 'in', label: 'Está en (lista)', symbol: 'en' },
      { value: 'not_in', label: 'No está en (lista)', symbol: 'no en' }
    ]
  }
  return []
}

// Componente para una condición simple
const ConditionRow = ({ condition, onUpdate, onRemove, fields, getOperators }) => {
  const fieldConfig = fields[condition.field] || fields.clave_prod_serv
  const operators = getOperators(fieldConfig.type)
  
  const handleFieldChange = (newField) => {
    const newFieldConfig = fields[newField]
    const newOperators = getOperators(newFieldConfig.type)
    
    // Resetear operador si no es válido para el nuevo campo
    let newOperator = condition.operator
    if (!newOperators.find(op => op.value === condition.operator)) {
      newOperator = newOperators[0].value
    }
    
    // Resetear valor si cambió el tipo de campo
    let newValue = condition.value
    if (newFieldConfig.type !== fieldConfig.type) {
      newValue = ''
    }
    
    onUpdate({ ...condition, field: newField, operator: newOperator, value: newValue })
  }
  
  const handleValueChange = (newValue) => {
    // Parsear valor según el tipo
    let parsedValue = newValue
    if (fieldConfig.type === 'number') {
      if (condition.operator === 'between') {
        // Para "between", el valor debe ser una lista "min,max"
        const parts = String(newValue).split(',').map(p => p.trim())
        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          parsedValue = [parseFloat(parts[0]), parseFloat(parts[1])]
        } else {
          parsedValue = newValue
        }
      } else if (condition.operator === 'in' || condition.operator === 'not_in') {
        // Para "in" y "not_in", el valor debe ser una lista separada por comas
        const parts = String(newValue).split(',').map(p => p.trim())
        parsedValue = parts.filter(p => p !== '')
      } else {
        parsedValue = newValue === '' ? '' : parseFloat(newValue)
      }
    } else if ((condition.operator === 'in' || condition.operator === 'not_in') && fieldConfig.type === 'text') {
      // Para "in" y "not_in" en texto, el valor debe ser una lista separada por comas
      const parts = String(newValue).split(',').map(p => p.trim())
      parsedValue = parts.filter(p => p !== '')
    }
    
    onUpdate({ ...condition, value: parsedValue })
  }
  
  const getValueDisplay = () => {
    if (Array.isArray(condition.value)) {
      return condition.value.join(', ')
    }
    return condition.value || ''
  }
  
  const getValuePlaceholder = () => {
    if (condition.operator === 'between') {
      return 'Ej: 1000,5000 (mínimo,máximo)'
    }
    if (condition.operator === 'in' || condition.operator === 'not_in') {
      return 'Ej: valor1,valor2,valor3'
    }
    return 'Ingresar valor...'
  }
  
  const isValid = () => {
    if (!condition.field || !condition.operator) return false
    if (condition.value === '' || condition.value === null || condition.value === undefined) return false
    if (Array.isArray(condition.value) && condition.value.length === 0) return false
    if (condition.operator === 'between' && (!Array.isArray(condition.value) || condition.value.length !== 2)) return false
    return true
  }
  
  return (
    <Row className="mb-2 align-items-end">
      <Col md={4}>
        <Form.Label><small>Campo</small></Form.Label>
        <Form.Select
          value={condition.field || 'clave_prod_serv'}
          onChange={(e) => handleFieldChange(e.target.value)}
          size="sm"
        >
          {Object.entries(fields).map(([key, config]) => (
            <option key={key} value={key}>{config.label}</option>
          ))}
        </Form.Select>
      </Col>
      <Col md={3}>
        <Form.Label><small>Operador</small></Form.Label>
        <Form.Select
          value={condition.operator || 'equals'}
          onChange={(e) => onUpdate({ ...condition, operator: e.target.value })}
          size="sm"
        >
          {operators.map((op) => (
            <option key={op.value} value={op.value}>{op.label}</option>
          ))}
        </Form.Select>
      </Col>
      <Col md={4}>
        <Form.Label><small>Valor</small></Form.Label>
        {fieldConfig.type === 'enum' && (condition.operator === 'equals' || condition.operator === 'not_equals') ? (
          <Form.Select
            value={condition.value || ''}
            onChange={(e) => onUpdate({ ...condition, value: e.target.value })}
            size="sm"
          >
            <option value="">Seleccionar...</option>
            {fieldConfig.options.map((opt) => {
              const v = optValue(opt)
              const lb = optLabel(opt)
              return (
                <option key={v} value={v}>{lb}</option>
              )
            })}
          </Form.Select>
        ) : (
          <Form.Control
            type={fieldConfig.type === 'number' ? 'number' : 'text'}
            value={getValueDisplay()}
            onChange={(e) => handleValueChange(e.target.value)}
            placeholder={getValuePlaceholder()}
            size="sm"
            className={!isValid() ? 'border-warning' : ''}
          />
        )}
      </Col>
      <Col md={1}>
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => onRemove()}
          title="Eliminar condición"
        >
          ✕
        </Button>
      </Col>
    </Row>
  )
}

// Componente para un grupo de condiciones
const ConditionGroup = ({ group, path, onUpdate, onRemove, level = 0, fields, getOperators, isRoot = false }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  
  const addCondition = () => {
    const newCondition = {
      field: 'clave_prod_serv',
      operator: 'equals',
      value: ''
    }
    const newConditions = [...(group.conditions || []), newCondition]
    onUpdate({ ...group, conditions: newConditions })
  }
  
  const addGroup = () => {
    const newGroup = {
      operator: 'AND',
      conditions: [],
      groups: []
    }
    const newGroups = [...(group.groups || []), newGroup]
    onUpdate({ ...group, groups: newGroups })
  }
  
  const updateCondition = (index, updatedCondition) => {
    const newConditions = [...(group.conditions || [])]
    newConditions[index] = updatedCondition
    onUpdate({ ...group, conditions: newConditions })
  }
  
  const removeCondition = (index) => {
    const newConditions = [...(group.conditions || [])]
    newConditions.splice(index, 1)
    onUpdate({ ...group, conditions: newConditions })
  }
  
  const updateNestedGroup = (index, updatedGroup) => {
    const newGroups = [...(group.groups || [])]
    newGroups[index] = updatedGroup
    onUpdate({ ...group, groups: newGroups })
  }
  
  const removeNestedGroup = (index) => {
    const newGroups = [...(group.groups || [])]
    newGroups.splice(index, 1)
    onUpdate({ ...group, groups: newGroups })
  }
  
  const hasContent = () => {
    return (group.conditions && group.conditions.length > 0) || (group.groups && group.groups.length > 0)
  }
  
  const borderStyle = level === 0 ? '2px solid #0d6efd' : level === 1 ? '2px solid #198754' : '1px solid #6c757d'
  const bgColor = level === 0 ? '#f8f9fa' : level === 1 ? '#f0f9f4' : '#ffffff'
  
  return (
    <Card className="mb-3" style={{ border: borderStyle, backgroundColor: bgColor }}>
      <Card.Header 
        style={{ cursor: 'pointer', backgroundColor: 'transparent', border: 'none', paddingBottom: '0.5rem' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <strong>
              {isRoot ? 'Condiciones Principales' : `Grupo (${group.operator || 'AND'})`}
            </strong>
            <Badge bg={group.operator === 'AND' ? 'primary' : 'success'}>
              {group.operator || 'AND'}
            </Badge>
            {!hasContent() && (
              <Badge bg="warning">Vacío</Badge>
            )}
          </div>
          {!isRoot && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={(e) => {
                e.stopPropagation()
                onRemove()
              }}
            >
              ✕ Eliminar Grupo
            </Button>
          )}
        </div>
      </Card.Header>
      
      {isExpanded && (
        <Card.Body>
          {/* Selector de operador lógico */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label><small>Operador Lógico del Grupo</small></Form.Label>
              <Form.Select
                value={group.operator || 'AND'}
                onChange={(e) => onUpdate({ ...group, operator: e.target.value })}
                size="sm"
              >
                <option value="AND">Y (AND) - Todas deben cumplirse</option>
                <option value="OR">O (OR) - Al menos una debe cumplirse</option>
              </Form.Select>
              <Form.Text className="text-muted">
                <small>
                  {group.operator === 'AND'
                    ? 'Todas las condiciones y grupos deben cumplirse'
                    : 'Al menos una condición o grupo debe cumplirse'}
                </small>
              </Form.Text>
            </Col>
            <Col md={6} className="d-flex align-items-end gap-2">
              <Button variant="outline-primary" size="sm" onClick={addCondition}>
                + Condición
              </Button>
              {level < 2 && (
                <Button variant="outline-success" size="sm" onClick={addGroup}>
                  + Grupo Anidado
                </Button>
              )}
            </Col>
          </Row>
          
          {/* Condiciones simples */}
          {group.conditions && group.conditions.length > 0 && (
            <div className="mb-3">
              <h6 className="mb-2"><small>Condiciones:</small></h6>
              {group.conditions.map((condition, index) => (
                <ConditionRow
                  key={`condition-${path}-${index}`}
                  condition={condition}
                  index={index}
                  onUpdate={(updated) => updateCondition(index, updated)}
                  onRemove={() => removeCondition(index)}
                  fields={fields}
                  getOperators={getOperators}
                />
              ))}
            </div>
          )}
          
          {/* Grupos anidados */}
          {group.groups && group.groups.length > 0 && (
            <div className="mb-3">
              <h6 className="mb-2"><small>Grupos Anidados:</small></h6>
              {group.groups.map((nestedGroup, index) => (
                <ConditionGroup
                  key={`group-${path}-${index}`}
                  group={nestedGroup}
                  path={`${path}-${index}`}
                  onUpdate={(updated) => updateNestedGroup(index, updated)}
                  onRemove={() => removeNestedGroup(index)}
                  level={level + 1}
                  fields={fields}
                  getOperators={getOperators}
                />
              ))}
            </div>
          )}
          
          {/* Mensaje si no hay contenido */}
          {!hasContent() && (
            <Alert variant="info" className="mb-0">
              <small>
                <strong>Grupo vacío:</strong> Agrega condiciones o grupos anidados para que este grupo tenga efecto.
              </small>
            </Alert>
          )}
        </Card.Body>
      )}
    </Card>
  )
}

// Componente principal ConditionBuilder
const ConditionBuilder = ({ value, onChange }) => {
  const [conditions, setConditions] = useState(value || { operator: 'AND', conditions: [], groups: [] })
  const [showPreview, setShowPreview] = useState(false)
  
  // Actualizar condiciones locales y notificar al padre
  const updateConditions = (updated) => {
    setConditions(updated)
    onChange(updated)
  }
  
  // Formatear condiciones para preview
  const formatPreview = (cond, level = 0) => {
    if (!cond || !cond.conditions && !cond.groups) {
      return 'Sin condiciones específicas'
    }
    
    const indent = '  '.repeat(level)
    const parts = []
    
    // Formatear condiciones simples
    if (cond.conditions && cond.conditions.length > 0) {
      cond.conditions.forEach((c, _idx) => {
        const fieldConfig = FIELDS[c.field] || FIELDS.clave_prod_serv
        const fieldLabel = fieldConfig.label
        const operators = getOperators(fieldConfig.type)
        const operatorConfig = operators.find(op => op.value === c.operator) || { label: c.operator, symbol: c.operator }
        const operatorLabel = operatorConfig.symbol || operatorConfig.label
        
        let valueDisplay = c.value
        if (Array.isArray(c.value)) {
          valueDisplay = c.operator === 'between' && c.value.length === 2
            ? `${c.value[0]} y ${c.value[1]}`
            : c.value.join(', ')
        }
        
        parts.push(`${indent}${fieldLabel} ${operatorLabel} ${valueDisplay}`)
      })
    }
    
    // Formatear grupos anidados
    if (cond.groups && cond.groups.length > 0) {
      cond.groups.forEach((group, _idx) => {
        parts.push(`${indent}(${formatPreview(group, level + 1)})`)
      })
    }
    
    if (parts.length === 0) {
      return 'Sin condiciones'
    }
    
    const operator = cond.operator || 'AND'
    return parts.join(` ${operator} `)
  }
  
  // Validar condiciones
  const validateConditions = (cond) => {
    if (!cond || (!cond.conditions && !cond.groups)) {
      return { valid: true, errors: [] }
    }
    
    const errors = []
    
    // Validar condiciones simples
    if (cond.conditions) {
      cond.conditions.forEach((c, idx) => {
        if (!c.field || !c.operator) {
          errors.push(`Condición ${idx + 1}: Falta campo u operador`)
        }
        if (c.value === '' || c.value === null || c.value === undefined) {
          errors.push(`Condición ${idx + 1}: Falta valor`)
        }
        if (Array.isArray(c.value) && c.value.length === 0) {
          errors.push(`Condición ${idx + 1}: Lista de valores vacía`)
        }
        if (c.operator === 'between' && (!Array.isArray(c.value) || c.value.length !== 2)) {
          errors.push(`Condición ${idx + 1}: "Entre" requiere exactamente 2 valores`)
        }
      })
    }
    
    // Validar grupos anidados recursivamente
    if (cond.groups) {
      cond.groups.forEach((group, idx) => {
        const nestedValidation = validateConditions(group)
        if (!nestedValidation.valid) {
          nestedValidation.errors.forEach(err => {
            errors.push(`Grupo ${idx + 1}: ${err}`)
          })
        }
      })
    }
    
    return { valid: errors.length === 0, errors }
  }
  
  const validation = validateConditions(conditions)
  
  return (
    <div>
      <ConditionGroup
        group={conditions}
        path="root"
        onUpdate={updateConditions}
        onRemove={() => {}}
        level={0}
        isRoot={true}
        fields={FIELDS}
        getOperators={getOperators}
      />
      
      {/* Preview y validación */}
      <Row className="mt-3">
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Button
              variant="outline-info"
              size="sm"
              onClick={() => setShowPreview(!showPreview)}
            >
              {showPreview ? 'Ocultar' : 'Mostrar'} Preview
            </Button>
            {!validation.valid && (
              <Badge bg="danger">Hay errores en las condiciones</Badge>
            )}
            {validation.valid && (conditions.conditions?.length > 0 || conditions.groups?.length > 0) && (
              <Badge bg="success">Condiciones válidas</Badge>
            )}
          </div>
          
          {showPreview && (
            <Alert variant="info" className="mb-0">
              <strong>Preview de condiciones:</strong>
              <pre style={{ marginBottom: 0, whiteSpace: 'pre-wrap', fontSize: '0.9em' }}>
                {formatPreview(conditions)}
              </pre>
            </Alert>
          )}
          
          {!validation.valid && (
            <Alert variant="danger" className="mt-2">
              <strong>Errores de validación:</strong>
              <ul className="mb-0" style={{ fontSize: '0.9em' }}>
                {validation.errors.map((error, idx) => (
                  <li key={idx}>{error}</li>
                ))}
              </ul>
            </Alert>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default ConditionBuilder
